import * as React from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";

import {ROUTES} from "../../helpers/constants";
import {useState} from "react";
import {getValidationErrors} from "./validation";
import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import {fetchLoginUser} from "./loginSlice";
import Loader from "../ui/Loader";

const LoginPage = () => {

  const [email, setEmail] = useState("");
  const [formErrors, setFormErrors] = useState({email: [], password: []});
  const [password, setPassword] = useState("");

  const {userError, loginStatus} = useAppSelector((store) => store.loginState);

  let location = useLocation();
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isRestorePage = location && location.pathname === ROUTES.restore;

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name: string = event.target.name;
    const value = event.target.value;
    if (name === "email") {
      setEmail(value);
    } else {
      setPassword(value);
    }
    // @ts-ignore
    if (formErrors[name] && formErrors[name].length) {
      const fieldErrors = getValidationErrors(name, value);
      setFormErrors(Object.assign({}, formErrors, {
        [name]: fieldErrors
      }))
    }
  }
  const onInputBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fieldErrors = getValidationErrors(event.target.name, event.target.value);
    setFormErrors(Object.assign({}, formErrors, {
      [event.target.name]: fieldErrors
    }))
  }

  const onFormSubmit = async (event: React.MouseEvent) => {
    event.preventDefault();
    let emailErrors = getValidationErrors("email", email);
    if (emailErrors.length) {
      setFormErrors(Object.assign({}, formErrors, {
        "email": emailErrors
      }))
    }
    const passwordErrors = getValidationErrors("password", password);
    if (passwordErrors.length) {
      setFormErrors(Object.assign({}, formErrors, {
        "email": emailErrors,
        "password": passwordErrors
      }))
    }
    if (emailErrors.length || passwordErrors.length) {
      return false
    }
    if (isRestorePage) {
      return false
    }
    dispatch(fetchLoginUser({email, password, navigate}));
  }

  const hasEmailError = formErrors.email && formErrors.email.length;
  const hasPasswordError = formErrors.password && formErrors.password.length;

  return (
    <section className="section">
      <div className="container">
        <div className="login">
          {isRestorePage
            ? <span className="title max-380 black bold auto block text-center margin-b-50">Forgot Your Password? <br/>No Worries – Reset It Here</span>
            : <span className="title max-380 black bold auto block text-center margin-b-50">Welcome Back! <br/>Please Sign In To Continue</span>}
          <form className="margin-0" action="">
            <div className="flex flex--column flex--top ui-input__block">
              <input className={"ui-input width-100" + (hasEmailError ? " ui-input--error" : "")}
                     type="email"
                     name="email"
                     id="email"
                     value={email}
                     onChange={onInputChange}
                     onBlur={onInputBlur}
                     placeholder="jason@mail.com"/>
              <label className="ui-label" htmlFor="email">Email Address</label>
              {hasEmailError ? <span className="red">{formErrors.email[0]}</span> : null}
            </div>
            {isRestorePage ? null : (
              <div className="flex flex--column flex--top ui-input__block">
                <input className={"ui-input width-100" + (hasPasswordError ? " ui-input--error" : "")}
                       type="password"
                       name="password"
                       id="password"
                       onChange={onInputChange}
                       onBlur={onInputBlur}
                       placeholder="Your password"/>
                <label className="ui-label" htmlFor="password">Password</label>
                {hasPasswordError ? <span className="red">{formErrors.password[0]}</span> : null}
                {userError && !hasPasswordError ? <span className="red">{userError}</span> : null}
              </div>
            )}
            <div className="margin-b-30 margin-t-30">
              <button type="submit"
                      onClick={onFormSubmit}
                      className="ui-button ui-button--darkblue width-100 ui-form__submit margin-b-0">
                {isRestorePage ? "Reset Password" : "Sign In"}
                {loginStatus === "loading" ? (
                  <span className="ui-button__loader ui-button__loader--after">
                    <Loader size={"button"}/>
                  </span>
                ) : null}
              </button>
            </div>
            <div className="ui-form__block">
              {isRestorePage
                ? <div className="gray text-center">Return to <Link to={ROUTES.login} className={"link link--blue2"}>Login</Link> page</div>
                : <div className="gray text-center">Forgot password? <Link to={ROUTES.restore} className={"link link--blue2"}>Reset</Link></div>}
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default LoginPage
